import React from "react";
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Input, Button } from "antd";
import FormItem from "antd/lib/form/FormItem";
import AuthService from "../../Services/AuthService";

interface Props {
  changeState: (newState: string) => void;
  setError: (error: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  form: any;
  initialLoginType?: "Password";
}

interface State {
  loginType: "Password";
  loggingIn: boolean;
  currentForm: string;
}

class ForgotPassword extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loginType: "Password",
      loggingIn: false,
      currentForm: "login"
    };
  }
  setLoginType = (type: "Password"): void => {
    this.setState({
      loginType: type
    });
  };
  forgotPassword = (): void => {
    this.props.setError("");
    const { form } = this.props;
    this.setState({
      loggingIn: true
    });
    form.validateFields(async (err: boolean, values: any) => {
      if (err) {
        this.setState({
          loggingIn: false
        });
        return;
      }
      // Initiate Auth, and once we receive the challenge back, we can redirect the user
      const authService = new AuthService();
      try {
        const resp = await authService.forgotPassword(values.email);
        this.props.changeState("submitForgotPassword");
      } catch (e) {
        this.props.setError(e.message || "An error occurred");
      }
    });
  };
  goToSignup = (): void => {
    this.props.changeState("signUp");
  };
  handleKeyPress = () => {
    console.log("event");
    // this.loginWithPassword();
  };
  render(): React.ReactElement {
    const { getFieldDecorator } = this.props.form;
    const { loggingIn } = this.state;

    return (
      <Form>
        <h2>Forgot Password</h2>
        <FormItem>
          {getFieldDecorator("email", {
            rules: [{ required: true, message: "Please input your email!" }]
          })(
            <Input placeholder="Email" />
          )}
        </FormItem>

        <FormItem>
          <>
            <Button
              type="primary"
              style={{ width: "100%" }}
              className="login-form-forgot"
              onClick={(): void => this.forgotPassword()}
            >
              Submit
            </Button>
            <Button
              type="link"
              className="login-form-forgot"
              onClick={(): void => {
                this.props.setError("");
                this.props.changeState("signIn");
              }}
            >
              Back to login
            </Button>
          </>
        </FormItem>
      </Form>
    );
  }
}

const WrappedForgotPassword = Form.create<Props>()(ForgotPassword);

export default WrappedForgotPassword;
